/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { Marker } from "react-map-gl";
import { Circle } from "@mui/icons-material";
import { CurrencyContext } from "../../../../contexts/AppContext";
import { ConvertedDeviseWithMoneySign } from "../../../../utils/CurrencyConvertFunction";
import { makeStyles, createStyles } from "@material-ui/styles";
import { CountryService } from "../../../Admin/Countries/services/EquipmentCountry";

const useStyles = makeStyles((theme) =>
    createStyles({
        circle: {
            color: "#890608",
            transition: "transform 0.15s ease-in-out",
            zIndex: 1,
            "&:hover": {
                transform: "scale3d(1.5, 1.5, 1)",
                color: "#EA7606",
                zIndex: 3,
            },
        },
        pin: {
            color: "#FFFCF0",
            backgroundColor: "#EA7606",
            padding: "2px",
            border: "solid #FFFCF0 1px",
            borderRadius: "10px",
            transition: "transform .5s ease-in-out",
            transform: "scale3d(1.5, 1.5, 1)",
            zIndex: 1,
        },
    })
);

export const SearchMarker = (props: any) => {
    const {
        p,
        showPrice,
        handleMarkerClick,
        isOnhover,
        viewport,
        handleHoverOn,
        handleHoverOff,
    } = props;

    const classes = useStyles();

    const [priceConvertedInitial, setPriceConvertedInitial] =
        React.useState<number>(0);
    const [commissionFee, setCommissionFee] = React.useState<number>(0);
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;

    const countryService = new CountryService();

    React.useEffect(() => {
        if (p?.propertyData[0].propertyTypeData[0].name === "Hôtel") {
            countryService
                .getSpecialFeeByPropertyType(
                    p?.propertyData[0].propertyTypeData[0].name
                )
                .then((respCom) => {
                    if (respCom.success) {
                        const percentage = respCom.data
                            ? respCom.data.percentageTraveller
                            : 0;
                        setCommissionFee(percentage);
                        const basePrice = p.price;
                        const normalBasePrice = (
                            basePrice +
                            basePrice * (percentage / 100)
                        ).toFixed(2);
                        ConvertedDeviseWithMoneySign(
                            p.devise || "eur",
                            currency,
                            normalBasePrice
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    } else {
                        ConvertedDeviseWithMoneySign(
                            p.devise || "eur",
                            currency,
                            p.price
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    }
                });
        } else {
            countryService
                .getCommissionFeeByCountryIdAndCityId(
                    p?.propertyData[0]?.address?.country,
                    p?.propertyData[0]?.address?.city
                )
                .then((respCom) => {
                    //console.log("CommissionFeeByCountryIdAndCityId from SearchMarker")
                        if (respCom.success) {
                        const percentage = respCom.data
                            ? respCom.data.percentage
                            : 0;
                        setCommissionFee(percentage);
                        const basePrice = p.price;
                        const normalBasePrice = (
                            basePrice +
                            basePrice * (percentage / 100)
                        ).toFixed(2);
                        ConvertedDeviseWithMoneySign(
                            p.devise || "eur",
                            currency,
                            normalBasePrice
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    } else {
                        ConvertedDeviseWithMoneySign(
                            p.devise || "eur",
                            currency,
                            p.price
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    }
                });
        }
    }, [currency, p.devise, p.price]);

    return (
        <>
            <Marker
                longitude={p.propertyData[0].location.longitude}
                latitude={p.propertyData[0].location.latitude}
                key={p._id}
            >
                <div
                    onClick={() => handleMarkerClick(p._id)}
                    key={p._id}
                    className={classes.circle}
                    onMouseEnter={() => handleHoverOn(p._id)}
                    onMouseLeave={() => handleHoverOff()}
                >
                    {showPrice && p._id === isOnhover ? (
                        <div
                            className={classes.pin}
                            style={{
                                fontSize: viewport.zoom * 1.1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {priceConvertedInitial !== 0
                                ? priceConvertedInitial
                                : p.price}
                        </div>
                    ) : (
                        <Circle style={{ fontSize: viewport.zoom * 2.6 }} />
                    )}
                </div>
            </Marker>
        </>
    );
};
